"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classNames = _interopRequireDefault(require("../classNames"));
var _react = _interopRequireDefault(require("react"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/NavBar/index.js";
var defaultProps = {
  navigateIcon: 'bi bi-list'
};
function NavBar(_ref) {
  var className = _ref.className,
    onClickNavigate = _ref.onClickNavigate,
    navigateIcon = _ref.navigateIcon,
    logo = _ref.logo,
    title = _ref.title,
    action = _ref.action;
  var classes = (0, _classNames["default"])(className, "navbar navbar-expand-lg navbar-light bg-white");
  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: classes,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-fluid",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClickNavigate,
    type: "button",
    className: "btn btn-sm btn-link fs-4 ps-0 text-dark",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: navigateIcon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 21
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex align-items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 17
    }
  }, logo && /*#__PURE__*/_react["default"].createElement("img", {
    className: "w-auto",
    src: logo,
    height: "40",
    alt: "title-logo",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 29
    }
  }), title && /*#__PURE__*/_react["default"].createElement("h6", {
    className: "fw-bold m-0 fs-5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 29
    }
  }, title)), action && action() || /*#__PURE__*/_react["default"].createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 40
    }
  })));
}
NavBar.defaultProps = defaultProps;
var _default = NavBar;
exports["default"] = _default;